import { K8sProvider } from '@cast/shared-types';
import { ClusterResponse } from '@cast/types';

export const isClusterManaged = (cluster?: ClusterResponse): boolean => {
  return (
    Boolean(cluster?.credentialsId) ||
    cluster?.providerType === K8sProvider.ANYWHERE
  );
};
